/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { LoadingOverlay as KitLoadingOverlay } from '@vaas/react-ui-kit';

import { cn } from '@/lib/cn';
import './loading.css';

interface LoadingOverlayProps {
  /** Announced, and printed above the bar. */
  label: string;
  /** 0-100 when the work reports real progress (e.g. the 3D viewer's download). */
  value?: number;
  /** Defaults to the progress card; `spinner` is the kit's compact form. */
  indicator?: 'spinner' | 'progress';
  className?: string;
}

/**
 * Frosted cover for a panel or canvas that is being replaced rather than filled in. Positioned
 * absolutely, so the host needs `position: relative`.
 *
 * The kit's overlay (`aria-busy`, swallows clicks on the stale content underneath) in its
 * label-and-progress-card form, which is the one this app has always shown; the kit's default is a
 * spinner. `.ld-overlay` keeps the cover on the host's local stacking level (see loading.css) and
 * is the hook tests query.
 */
export function LoadingOverlay({
  label,
  value,
  indicator = 'progress',
  className,
}: LoadingOverlayProps) {
  return (
    <KitLoadingOverlay
      indicator={indicator}
      label={label}
      value={value}
      className={cn('ld-overlay', className)}
    />
  );
}
